import strategoMobile from "./stratego-mobile.png";
import strategoDesktop from "./stratego-desktop.png";
import magicMobile from "./magic-mobile.jpg";
import magicDesktop from "./magic-desktop.jpg";
import campaigs40kMobile from "./40k-mobile.jpeg";
import campaigs40kDesktop from "./stratego-desktop.png";
import pooperBowlMobile from "./blood-bowl-mobile.jpeg";
import pooperBowlDesktop from "./blood-bowl-desktop.jpeg";

export const images = {
  strategoMobile: strategoMobile,
  strategoDesktop: strategoDesktop,
  magicMobile: magicMobile,
  magicDesktop: magicDesktop,
  campaigs40kMobile: campaigs40kMobile,
  campaigs40kDesktop: campaigs40kDesktop,
  pooperBowlMobile: pooperBowlMobile,
  pooperBowlDesktop: pooperBowlDesktop,
};
